import { Button, Col, Form, Input, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import { createEntity, getEntity, updateEntity } from '../work-group.reducer';

export const WorkTypeUpdate = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { id } = useParams();
  const isNew = id === undefined;

  const planPeriodEntity = useAppSelector(state => state.workGroup.entity);
  const updating = useAppSelector(state => state.workGroup.updating);
  const updateSuccess = useAppSelector(state => state.workGroup.updateSuccess);

  const handleClose = () => {
    form.resetFields();
    navigate('/work-type');
  };

  useEffect(() => {
    innitData();
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (planPeriodEntity && !isNew) {
      form.setFieldsValue(planPeriodEntity);
    }
  }, [planPeriodEntity]);

  const innitData = () => {
    // get detail
    if (isNew) {
      form.resetFields();
    } else {
      dispatch(getEntity(id));
    }
  };

  const handleSubmit = values => {
    const oldEntity = !isNew && planPeriodEntity;
    const entity = {
      ...oldEntity,
      ...values,
    };
    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  return (
    <Container className="form">
      <Form size="large" form={form} initialValues={{ isEnabled: true }} onFinish={handleSubmit} layout="vertical">
        <Title level={3}>{`${id ? 'Cập nhật thông tin' : 'Thêm mới'} mảng công việc`}</Title>
        <Row>
          <Col md={24}>
            <Form.Item label="Tên mảng công việc" rules={[{ required: true, message: 'Hãy nhập tên mảng công việc' }]} name="name">
              <Input className="w-100" size="large" placeholder="Nhập ên mảng công việc" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Row className="action mt-3" justify="end">
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={updating}>
                Lưu
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default WorkTypeUpdate;
